import React from "react";
import { Box, Card, Typography, Stack, Select, MenuItem, FormControl } from "@mui/material";

import curveArrowRedUp from "../../assets/WidgetsIcon/curve-arrow-red-up.svg";
import pulseIcon from "../../assets/WidgetsIcon/pulse.svg";
import dollarIcon from "../../assets/WidgetsIcon/dollar.svg";
import curveArrowGreenDown from "../../assets/WidgetsIcon/curve-arrow-green-down.svg";

const IncidentImpact = () => {
  return (
    <Card
      className="p-3"
      sx={{
        boxShadow: "0px 4px 4px 0px #0000000F",
      }}
    >
      <Stack
        direction="row"
        spacing={2}
        sx={{
          justifyContent: "space-between",
          alignItems: "center",
          mb: 3,
        }}
      >
        <Typography
          variant="h5"
          sx={{
            marginLeft: 1,
            fontWeight: 700,
            lineHeight: "20px",
          }}
        >
          Incident Impact
        </Typography>
      </Stack>
      <Stack
        direction="row"
        spacing={2}
        useFlexGap
        sx={{
          alignItems: "center",
          flexWrap: "wrap",
        }}
      >
        <Box
          className="d-flex flex-column justify-content-between"
          sx={{
            px: 2,
            py: "12px",
            border: "1px solid #E1E1E1",
            borderRadius: "8px",
            height: 170,
          }}
        >
          <Box className="d-flex">
            <img src={dollarIcon} alt="noticeIcon" />{" "}
            <Typography
              variant="h6"
              sx={{
                marginLeft: 1,
                fontWeight: 700,
                lineHeight: "20px",
              }}
            >
              Property Damage
            </Typography>
          </Box>
          <Box className="d-flex align-items-baseline mt-auto mb-2">
            <Typography
              variant="h4"
              sx={{
                marginRight: 1,
                fontWeight: 700,
              }}
            >
              $1,245,800
            </Typography>
            <img src={curveArrowRedUp} alt="curveArrow" className="me-1" />
            <Typography variant="body2" sx={{ color: "#C71818", fontWeight: 600 }} className="me-2">
              8.5%
            </Typography>
            <Typography variant="body2" sx={{ color: "#00000078" }}>
              previous 7 days
            </Typography>
          </Box>
          <Typography variant="body2">total estimated damage</Typography>
        </Box>

        <Box
          className="d-flex flex-column justify-content-between"
          sx={{
            px: 2,
            py: "12px",
            border: "1px solid #E1E1E1",
            borderRadius: "8px",
            height: 170,
            minWidth: 460,
          }}
        >
          <Box className="d-flex">
            <img src={pulseIcon} alt="noticeIcon" />{" "}
            <Typography
              variant="h6"
              sx={{
                marginLeft: 1,
                fontWeight: 700,
                lineHeight: "20px",
              }}
            >
              Casualties & Injuries
            </Typography>
          </Box>
          <Stack
            direction="row"
            spacing={2}
            sx={{
              justifyContent: "space-between",
              alignItems: "center",
              height: "100%",
              mt: 1,
            }}
          >
            <Box
              sx={{
                minWidth: "130px",
                pb: 0,
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                flex: 1,
                height: "100%",
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  fontWeight: 600,
                }}
              >
                <Typography
                  component="span"
                  sx={{
                    fontSize: "20px",
                    fontWeight: 700,
                  }}
                >
                  8 {""}
                </Typography>
                civilian
              </Typography>

              <Box className="d-flex">
                <img src={curveArrowGreenDown} alt="curveArrow" className="me-1" />
                <Typography variant="body2" sx={{ color: "#45856B", fontWeight: 600 }} className="me-2">
                  56%
                </Typography>
                <Typography variant="body2" sx={{ color: "#00000078" }}>
                  previous 7 days
                </Typography>
              </Box>

              <Box className="d-flex">
                <Box sx={{ mr: 3 }}>
                  <Typography variant="body2" sx={{ lineHeight: "25px" }}>
                    7 <br /> Injuries
                  </Typography>
                </Box>
                <Box>
                  <Typography variant="body2" sx={{ lineHeight: "25px" }}>
                    1 <br /> Fatalities
                  </Typography>
                </Box>
              </Box>
            </Box>

            <Box
              sx={{
                minWidth: "130px",
                pb: 0,
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                flex: 1,
                height: "100%",
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  fontWeight: 600,
                }}
              >
                <Typography
                  component="span"
                  sx={{
                    fontSize: "20px",
                    fontWeight: 700,
                  }}
                >
                  3 {""}
                </Typography>
                FF/EMS
              </Typography>

              <Box className="d-flex">
                <img src={curveArrowGreenDown} alt="curveArrow" className="me-1" />
                <Typography variant="body2" sx={{ color: "#45856B", fontWeight: 600 }} className="me-2">
                  96%
                </Typography>
                <Typography variant="body2" sx={{ color: "#00000078" }}>
                  previous 7 days
                </Typography>
              </Box>

              <Box className="d-flex">
                <Box sx={{ mr: 3 }}>
                  <Typography variant="body2" sx={{ lineHeight: "25px" }}>
                    3 <br /> Injuries
                  </Typography>
                </Box>
                <Box>
                  <Typography variant="body2" sx={{ lineHeight: "25px" }}>
                    0 <br /> Fatalities
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Stack>
        </Box>
      </Stack>
    </Card>
  );
};

export default IncidentImpact;
